import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Camera, Instagram, ArrowRight } from 'lucide-react';
import { FadeIn, StaggerContainer, StaggerItem } from './Animations';
const projects = [{
  src: 'https://cdn.magicpatterns.com/uploads/9xtkJAr7hK44a2vw9qRwjt/JEZ1.png',
  title: 'Loaded & Ready to Haul',
  category: 'Residential Cleanout',
  location: 'Fresno, CA'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/udRv5hzN8xwYbWhCezHYEh/JEZ3.png',
  title: 'Yard Debris Cleanup',
  category: 'Yard & Outdoor',
  location: 'Clovis, CA'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/xjRyXyrSDRo3czXeF8iVAK/JEZ4.png',
  title: 'Construction Debris Haul',
  category: 'Construction',
  location: 'Visalia, CA'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/poAwFT86Avp4UnkEbcNqmw/JEZ7.png',
  title: 'Furniture Removal Job',
  category: 'Furniture Haul',
  location: 'Sanger, CA'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nFo6Gtdg4EzPVdaFrV2Kpg/JEZ5.png',
  title: 'On-Site Service Trailer',
  category: 'Our Equipment',
  location: 'Central Valley'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rUZZZJRrXVQqjVGBUQnP3V/JEZ2.png',
  title: 'Before & After Transformation',
  category: 'Property Cleanout',
  location: 'Madera, CA'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iqZWJVDdm9gqpgwoaVu37U/JEZ6.png',
  title: 'Green Waste & Brush Removal',
  category: 'Yard & Outdoor',
  location: 'Reedley, CA'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/e9BMZN1ay66wUqFvhoJwab/JEZ8.png',
  title: 'Appliance Removal Service',
  category: 'Appliances',
  location: 'Hanford, CA'
}];
export const Gallery = () => {
  const [activeIdx, setActiveIdx] = useState<number | null>(null);
  const close = () => setActiveIdx(null);
  const next = () => setActiveIdx(i => i === null ? null : (i + 1) % projects.length);
  const prev = () => setActiveIdx(i => i === null ? null : (i - 1 + projects.length) % projects.length);
  return <section id="gallery" className="py-20 md:py-24 bg-white relative overflow-hidden" data-id="element-229">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-brand-red/5 rounded-full blur-3xl pointer-events-none" data-id="element-230" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
        <FadeIn className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12" data-id="element-232">
          <div className="max-w-2xl" data-id="element-233">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand-red mb-4" data-id="element-234">
              Our Work
            </div>
            <h2 className="font-oswald text-4xl md:text-5xl font-bold uppercase text-brand-black leading-tight" data-id="element-235">
              Recent <span className="text-brand-red" data-id="element-236">Jobs</span> &amp; Projects
            </h2>
            <p className="text-zinc-600 text-lg mt-4" data-id="element-237">
              Real work, real results across the Central Valley. From small home
              cleanouts to full commercial hauls — we get it done.
            </p>
          </div>
          <a href="https://instagram.com/jezjunkaway" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-brand-black hover:text-brand-red font-oswald font-bold uppercase tracking-wide text-sm transition-colors group shrink-0" data-id="element-238">
            <Instagram className="w-4 h-4" data-id="element-239" />
            See More on Instagram
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-240" />
          </a>
        </FadeIn>

        {/* Asymmetric Grid */}
        <StaggerContainer className="grid grid-cols-2 md:grid-cols-4 auto-rows-[160px] md:auto-rows-[220px] gap-3 md:gap-4" data-id="element-241">
          {projects.map((p, idx) => {
          // Layout: item 0 = big feature (2x2), item 5 = wide (2x1)
          const spanClass = idx === 0 ? 'col-span-2 row-span-2' : idx === 5 ? 'col-span-2' : 'col-span-1';
          return <StaggerItem key={idx} className={`${spanClass} relative group cursor-pointer overflow-hidden rounded-sm bg-brand-black min-h-[180px]`} onClick={() => setActiveIdx(idx)} data-id="element-242">
                <img src={p.src} alt={p.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-243" />
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-brand-black/90 via-brand-black/40 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" data-id="element-244" />

                {/* Category badge */}
                <div className="absolute top-3 left-3 md:top-4 md:left-4" data-id="element-245">
                  <span className="bg-brand-red text-white text-[10px] md:text-xs font-oswald font-bold uppercase tracking-wider px-2.5 py-1 rounded-sm" data-id="element-246">
                    {p.category}
                  </span>
                </div>

                {/* Zoom icon */}
                <div className="absolute top-3 right-3 md:top-4 md:right-4 w-9 h-9 bg-white/10 backdrop-blur border border-white/20 flex items-center justify-center rounded-sm opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-247">
                  <Camera className="w-4 h-4 text-white" data-id="element-248" />
                </div>

                {/* Info bottom */}
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5 text-white translate-y-2 group-hover:translate-y-0 transition-transform duration-300" data-id="element-249">
                  <h3 className="font-oswald font-bold uppercase text-base md:text-xl leading-tight" data-id="element-250">
                    {p.title}
                  </h3>
                  <p className="text-xs md:text-sm text-zinc-300 mt-1" data-id="element-251">
                    {p.location}
                  </p>
                </div>
              </StaggerItem>;
        })}
        </StaggerContainer>

        {/* Bottom CTA */}
        <FadeIn delay={0.2} className="mt-12 text-center" data-id="element-252">
          <p className="text-zinc-600 mb-5" data-id="element-253">
            Your project could be next.{' '}
            <strong className="text-brand-black" data-id="element-254">
              Get a free quote today.
            </strong>
          </p>
          <a href="tel:+15597709442" className="inline-flex items-center gap-2 bg-brand-black hover:bg-brand-red text-white px-7 py-3.5 rounded-sm font-oswald font-bold uppercase tracking-wide transition-colors" data-id="element-255">
            Request a Quote
            <ArrowRight className="w-4 h-4" data-id="element-256" />
          </a>
        </FadeIn>
      </div>

      {/* Lightbox modal */}
      {activeIdx !== null && <div className="fixed inset-0 z-[100] bg-brand-black/95 flex items-center justify-center p-4 backdrop-blur-sm animate-in fade-in" onClick={close} data-id="element-257">
          <button className="absolute top-4 right-4 md:top-6 md:right-6 w-11 h-11 bg-white/10 hover:bg-brand-red border border-white/20 text-white flex items-center justify-center rounded-sm transition-colors z-10" onClick={close} aria-label="Close" data-id="element-258">
            <X className="w-5 h-5" data-id="element-259" />
          </button>

          <button className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 w-11 h-11 md:w-12 md:h-12 bg-white/10 hover:bg-brand-red border border-white/20 text-white flex items-center justify-center rounded-sm transition-colors z-10" onClick={e => {
        e.stopPropagation();
        prev();
      }} aria-label="Previous" data-id="element-260">
            <ChevronLeft className="w-5 h-5" data-id="element-261" />
          </button>

          <button className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-11 h-11 md:w-12 md:h-12 bg-white/10 hover:bg-brand-red border border-white/20 text-white flex items-center justify-center rounded-sm transition-colors z-10" onClick={e => {
        e.stopPropagation();
        next();
      }} aria-label="Next" data-id="element-262">
            <ChevronRight className="w-5 h-5" data-id="element-263" />
          </button>

          <div className="relative max-w-5xl w-full" onClick={e => e.stopPropagation()} data-id="element-264">
            <img src={projects[activeIdx].src} alt={projects[activeIdx].title} className="w-full max-h-[80vh] object-contain rounded-sm" data-id="element-265" />
            <div className="mt-4 text-center text-white" data-id="element-266">
              <span className="inline-block bg-brand-red text-white text-xs font-oswald font-bold uppercase tracking-wider px-3 py-1 rounded-sm mb-3" data-id="element-267">
                {projects[activeIdx].category}
              </span>
              <h3 className="font-oswald text-2xl md:text-3xl font-bold uppercase" data-id="element-268">
                {projects[activeIdx].title}
              </h3>
              <p className="text-zinc-400 mt-1" data-id="element-269">
                {projects[activeIdx].location}
              </p>
              <p className="text-xs text-zinc-500 mt-4" data-id="element-270">
                {activeIdx + 1} / {projects.length}
              </p>
            </div>
          </div>
        </div>}
    </section>;
};